import { FormCommonApiService } from '../../../../../service/api/formcommon-api.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { BaseForm } from '../../../../base-form';
import { ProductosApiService } from '../../../../../service/api/productos-api';
import { ProductosFitosanitariosFormDefinition } from './form-control/form-definition';
import { Utils } from '../../../../../common/utils';
import moment from 'moment';
import { HttpClient } from '@angular/common/http';

import { ProductosModel } from '../../../../../models/productos/productos.model';
import { ColInterface } from '../../../../../common/components/common-list-table/col.interface';
import { ColStylesInterface } from '../../../../../common/components/common-list-table/col-styles.interface';
import { Subject } from 'rxjs';
import { TreeNode } from 'primeng/api';
import { build, pool } from '../../../../../common/classes/request-builder';
import { ReactiveFormBuilderComponent } from '../../../../../common/components/reactive-form-builder/form-builder.component';
import { OtrasDenominacionesApiService } from '../../../../../service/api/otrasdenominaciones-api.service';
import { FormRequestTypes } from '../../../../../common/classes/form-request';
@Component({
    selector: 'app-stock-formulario-productos',
    standalone: false,
    templateUrl: './productos-form.component.html',
    styleUrls: ['./productos-form.component.scss']
})
export class ProductosFormComponent extends BaseForm<ProductosModel> implements OnInit, OnDestroy {
    @ViewChild(ReactiveFormBuilderComponent) formBuilder!: ReactiveFormBuilderComponent<ProductosModel>;
    public dropdownsFinalized = false;

    public dropdownLoadTrigger = new Subject<void>();
    public form: ProductosFitosanitariosFormDefinition = new ProductosFitosanitariosFormDefinition(
        this.getType(),
        this.getModel() as Record<string,string>,
        null
    );

    public formRequest: ReactiveFormBuilderComponent<ProductosModel>;
    public fecha_caducidad = '';

    public searchValue = {
        term: ''
    };

    constructor(public dashboardEvents: DashboardService,
        public formApi: FormCommonApiService,
        public productosApi: ProductosApiService,
        public otrasDenominaciones: OtrasDenominacionesApiService,
        public override router: Router,
        public override route: ActivatedRoute,
        public http: HttpClient) {
        super(
            route,
            router,
            dashboardEvents,
            productosApi.productos.PUT,
            productosApi.productos.POST,
            'productos',
            'Actualizar Fitosanitario',
            'Alta de Producto Fitosanitario',
        );
        this.formRequest = new ReactiveFormBuilderComponent(this.http);
    }

    ngOnInit(): void {
        this.dropdownsFinalized = false;
        
        this.productosApi.productos.POST.reset();
        this.productosApi.productos.PUT.reset();
        
        this.initFormData();
        this.softInit(this.getType());
    }


    formChanges(formModel: any, tag: string): void {
        // this.form.model = formModel;

        switch (tag) {
            case 'num_registro':
                this.form.model.nombre = formModel.num_registro.nombre_comercial;
                // this.productSelected(formModel.num_registro);
                break;
            
            case 'nombre':
                this.searchValue = {
                    term: this.form.model.otra_denominacion_comun === '1' ? 
                    this.form.lists.denominaciones_otras.selected.nombre_comercial : this.form.model.nombre ?? ''
                };
                break;
        }
    }

    public productSelected(row: any): void {
        const product = (row?.data ?? row) as ProductosModel;
        
        if (!product) {
            return;
        }        

        this.form.model.num_registro = product;
        this.form.model.nombre = product.nombre_comercial;
        this.form.model.materia_activa = product.composicion ?? product.materia_activa;
        this.fecha_caducidad = product.fecha_caducidad ?? '';
        
        this.formBuilder.updateForm(this.form.model, true);
    }

    
    public globalConditionalStyle(
        _cellValue: string,
        _colDefinition: ColInterface,
        _colGroup: ColInterface[],
        rowValue: TreeNode<ProductosModel>
    ): ColStylesInterface {
        const baseStyle: any = {
            color: 'black',
            backgroundColor: '#ffffff',
            borderBottom: '1px solid #dddddd'
        };

        const fechaCaducidad = Utils.toDate(rowValue.data?.fecha_caducidad ?? '');
        const fechaInscripcion = Utils.toDate(rowValue.data?.fecha_inscripcion ?? '');

        const diffCaducidad = moment().diff(fechaCaducidad, 'months');
        const diffInscripcion = moment().diff(fechaInscripcion, 'months');

        if (diffInscripcion < 12) {
            baseStyle.backgroundColor = '#cbdecb';
        }

        if (diffCaducidad > 12) {
            baseStyle.backgroundColor = '#222222';
            baseStyle.color = 'white';
        } else if (diffCaducidad > 6) {
            baseStyle.backgroundColor = '#ff7f7f';
        } else if (diffCaducidad >= 0) {
            baseStyle.backgroundColor = '#ffcf78';
        }

        return { rowStyle: baseStyle };
    }


    public globalVisualTransform(value: string): string {
        return value;
    }


    public override ngOnDestroy(): void {
        Utils.unsuscribe([
            this.formApi.magramaDetalleProducto,
        ]);
        Utils.unsuscribe([
            this.formApi.magramaProducto
        ]);
    }


    private initFormData(): Promise<boolean> {
        const builds = [
            build(
                this.formApi.productosVademecum, 
                this.form.lists.denominaciones_estandar, 
                ((it: ProductosModel) => {
                    const level = Utils.checkIfProductIsValid(it.fecha_caducidad, 'fitosanitario');
                    return level + ' [' + it.referencia + '] ' + it.nombre_comercial;
                })
            ),
            build(
                this.otrasDenominaciones.otrasDenominacionesGET, 
                this.form.lists.denominaciones_otras, 
                ((it: ProductosModel) => '[' + it.num_registro + '] ' + it.denominaciones_comunes + ' - ' + it.nombre_comercial)
            )
        ];
        return pool(builds, () => {

            this.dropdownsFinalized = true;
            this.dropdownLoadTrigger.next();
            
            if ([FormRequestTypes.EDIT, FormRequestTypes.DUPLICATE].includes(this.getType())) {
                
                const { num_registro = 0, nombre = '' } = this.getModel();
                const esDenominacionOtra = this.form.model.otra_denominacion_comun === '1';

                const listas = esDenominacionOtra 
                    ? this.form.lists.denominaciones_otras 
                    : this.form.lists.denominaciones_estandar;

                this.form.lists.productos = listas;

                const selected = listas.values.find(it => {
                    const value = it.value;
                    return esDenominacionOtra
                    ? value?.num_registro === num_registro && value?.denominaciones_comunes === nombre
                    : value?.referencia === num_registro;
                })?.value ?? null;

                this.form.lists.productos.selected = selected;
                this.form.model.num_registro = selected;

                this.formBuilder.updateForm(this.form.model, true);
            }
        });
    }

    override goBack(): void {
        window.history.back();
    }
}
